var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.741 0c4.414 0 8 3.586 8 8s-3.586 8-8 8-8-3.586-8-8 3.586-8 8-8zm0 11.2a.8.8 0 100 1.6.8.8 0 000-1.6zm0-7.564c-1.622 0-2.945 1.235-2.945 2.75-.004.251.14.49.378.62s.533.13.77 0a.704.704 0 00.379-.626c0-.73.63-1.318 1.418-1.318.788 0 1.418.588 1.418 1.323 0 .426-.162.748-.537 1.117-.212.208-.432.378-.917.723l-.078.055c-.16.115-.26.187-.363.264a.696.696 0 00-.286.557v1.018c-.004.252.14.49.378.62s.532.13.77 0a.704.704 0 00.379-.625c.006-.447.01-.672.013-.674l.178-.127c.15-.106.263-.189.375-.274.25-.189.461-.367.654-.556.613-.604.962-1.293.962-2.098 0-1.514-1.323-2.749-2.946-2.749z",
    fill: "#989898",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkGrey);
export default __webpack_public_path__ + "static/media/question-mark-grey.8019a5adff0761e6bf9efe956e99d1f1.svg";
export { ForwardRef as ReactComponent };